import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AccessDeniedComponent } from '../errors/components/access-denied/access-denied.component'
import { ArpioRootComponent } from './components/arpio-root/arpio-root.component'
import { TestPageComponent } from './components/test-page/test-page.component'
import { ArpioAlertComponent } from './arpio-alert/components/arp-alert/arpio-alert.component'

const routes: Routes = [
  { path: '', component: ArpioRootComponent },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'test_page', component: TestPageComponent },
  { path: 'alerts', component: ArpioAlertComponent },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ArpioRoutingModule {}
